function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "94.336,149.998 87.116,161.356 99.618,168.936 101.525,173.866 98.49,197.348 94.336,192.812  95.838,200 70.082,195.464 56.438,187.12 45.099,172.734 45.099,170.074 35.242,161.356 26.887,149.998 26.142,130.292  18.196,118.169 17.038,107.571 21.605,88.626 24.25,86.742 31.447,90.525 38.644,91.665 43.188,80.291 45.099,79.538 60.226,85.985  67.422,81.433 68.194,70.827 75.375,53.778 80.696,53.021 90.545,60.592 97.741,57.569 98.49,53.778 104.931,51.122 104.931,43.546  98.49,43.546 96.973,32.949 94.336,31.041 94.336,24.598 97.741,20.825 99.618,12.475 102.278,11.339 123.891,24.598  129.169,22.713 135.242,25.752 139.802,23.845 139.802,12.475 149.635,0 154.929,0 154.172,3.012 156.079,3.795 161.384,0  182.962,49.218 177.661,53.021 171.989,53.021 165.159,60.592 157.971,60.592 152.276,55.666 142.47,81.433 129.169,99.239  131.088,111.358 96.973,127.647 "
});

var Svg22 = function Svg22(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "QRO",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg22, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/22.c721b89d.svg";
export { ForwardRef as ReactComponent };